import {sbmNewsListingFilterHandler} from './components/views/sbmNewsListingFilterHandler';
import {isomResearhHighlightBlock} from './components/paragraphs/isomResearhHighlightBlock';
import {sbmProgramsLPM1} from './components/paragraphs/sbmProgramsLPM1';
import {sbmProgramsLPM19} from './components/paragraphs/sbmProgramsLPM19';
import {sbmPeopleListingHandler} from './components/views/sbmPeopleListingHandler';
import {sbmResposiveTables} from './components/paragraphs/sbmResposiveTables';
import {sbmBannerSlideshow} from './components/paragraphs/sbmBannerSlideshow';
import {programTabsBlock} from './components/paragraphs/program-tabs-block';
import {programCustomSelect} from "./components/paragraphs/program-custom-select";
import {sbmProgramMenu} from './components/paragraphs/sbmProgramMenu';
import {sbmPopUp} from './components/global/sbmPopUp';
import {sbmHeader} from './components/global/sbmHeader';

$ = jQuery;
(function ($, Drupal, window, document, undefined) {
    'use strict';
    Drupal.behaviors.MTPCSBMGlobal = {
        attach: function (context, settings) {
            sbmPeopleListingHandler();
            sbmNewsListingFilterHandler();
        },
    };
    $(function () {
        sbmHeader();
        isomResearhHighlightBlock();
        sbmProgramsLPM1();
        sbmProgramsLPM19();
        sbmResposiveTables();
        sbmBannerSlideshow();
        sbmBannerSlideshow();
        programTabsBlock();
        programCustomSelect();
        sbmPopUp();
        sbmProgramMenu(".sbm-program-menu ul.menu", true, "x");
    });
})(jQuery, Drupal, window);
